/* ===== GRIFO · interacciones (Shopify) ===== */
(function(){
  function ready(fn){ if(document.readyState!=='loading')fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    // reveal al hacer scroll
    function gfReveal(scope){
      var els=(scope||document).querySelectorAll('.grifo-reveal:not(.in)');
      // En el editor de Shopify mostramos todo sin animar (el observer no es fiable ahí)
      if(window.Shopify && Shopify.designMode){ els.forEach(function(el){el.classList.add('in');}); return; }
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
        els.forEach(function(el){io.observe(el);});
        // red de seguridad: si algo sigue oculto tras 1.5s, mostrarlo igualmente
        setTimeout(function(){ document.querySelectorAll('.grifo-reveal:not(.in)').forEach(function(el){ var r=el.getBoundingClientRect(); if(r.top < window.innerHeight){ el.classList.add('in'); } }); }, 1500);
      } else { els.forEach(function(el){el.classList.add('in');}); }
    }
    gfReveal(document);
    // re-escanear cuando el editor recarga una sección
    document.addEventListener('shopify:section:load', function(e){ gfReveal(e.target); });



    // --- Carrusel COVERFLOW circular del catálogo (inercia + perspectiva + blur) ---
    if(false){ // catálogo en cuadrícula normal (coverflow desactivado)
      var grid=document.getElementById('product-grid');
      if(grid && grid.classList.contains('product-grid') && !document.querySelector('.grifo-view-toggle')){
        var wrap=grid.parentNode;
        var cards=[].slice.call(grid.children);
        var bar=document.createElement('div');
        bar.className='grifo-view-toggle';
        bar.innerHTML='<button type="button" data-v="slider" class="on">Vitrina</button><button type="button" data-v="grid">Cuadrícula</button>';
        wrap.insertBefore(bar, grid);

        var pos=0, vel=0, raf=null, dragging=false, moved=false;
        var startX=0, lastX=0, lastT=0, startPos=0, sliderOn=false;
        var N=cards.length, maxPos=(N-1);
        var GAP=320;

        // limpia clases de animación de Dawn que pelean con el transform
        for(var k=0;k<N;k++){ cards[k].classList.remove('scroll-trigger','animate--slide-in'); }

        function recalcGap(){ GAP=Math.max(180, Math.min(340, wrap.clientWidth*0.42)); }

        function render(){
          var center=Math.round(pos);
          for(var i=0;i<N;i++){
            var c=cards[i];
            var d=i-pos, ad=Math.abs(d);
            if(ad>3){ c.style.display='none'; continue; }
            c.style.display='block';
            var x=d*GAP;
            var rot=Math.max(-55,Math.min(55,-d*25));
            var scale=Math.max(0.58,1-ad*0.18);
            var blur=Math.min(7, ad*2.6);
            var op=ad>2.4?0:Math.max(0,1-ad*0.42);
            c.style.transform='translate(-50%,-50%) translateX('+x+'px) rotateY('+rot+'deg) scale('+scale+')';
            c.style.filter= ad>0.05 ? 'blur('+blur+'px) brightness('+(1-ad*0.1).toFixed(2)+')' : 'none';
            c.style.opacity=op;
            c.style.zIndex=String(100-Math.round(ad*10));
            c.style.pointerEvents= ad<0.5 ? 'auto':'none';
            if(i===center){ c.classList.add('is-center'); } else { c.classList.remove('is-center'); }
          }
        }
        function clampPos(p){ return p<0?0:(p>maxPos?maxPos:p); }

        function animate(){
          if(dragging) return;
          vel*=0.92;
          pos+=vel;
          if(Math.abs(vel)<0.12){
            var target=Math.round(pos);
            pos+=(target-pos)*0.2;
            if(Math.abs(target-pos)<0.003){ pos=target; render(); return; }
          }
          if(pos<0){pos=0;vel=0;} else if(pos>maxPos){pos=maxPos;vel=0;}
          render();
          raf=requestAnimationFrame(animate);
        }

        function onDown(e){
          if(!sliderOn) return;
          dragging=true; moved=false;
          if(raf) cancelAnimationFrame(raf);
          startX=lastX=e.clientX; startPos=pos; lastT=performance.now(); vel=0;
          grid.classList.add('dragging');
          try{ grid.setPointerCapture(e.pointerId); }catch(_){}
        }
        function onMove(e){
          if(!dragging) return;
          var now=performance.now(), dt=(now-lastT)||16, dx=e.clientX-lastX;
          var dpos=dx/GAP;
          vel=-(dpos/dt*16);
          pos=clampPos(startPos-(e.clientX-startX)/GAP);
          render();
          lastX=e.clientX; lastT=now;
          if(Math.abs(e.clientX-startX)>6) moved=true;
        }
        function onUp(){
          if(!dragging) return;
          dragging=false; grid.classList.remove('dragging');
          raf=requestAnimationFrame(animate);
        }
        grid.addEventListener('pointerdown', onDown);
        grid.addEventListener('pointermove', onMove);
        grid.addEventListener('pointerup', onUp);
        grid.addEventListener('pointercancel', onUp);
        grid.addEventListener('lostpointercapture', onUp);
        // click en una tarjeta lateral → centrarla (no navegar); click en la central → entra
        grid.addEventListener('click', function(e){
          if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; return; }
          var li=e.target.closest('.product-grid > *, #product-grid > *'); 
          if(!li) return;
          var idx=cards.indexOf(li);
          if(idx>-1 && Math.abs(idx-pos)>0.5){ e.preventDefault(); e.stopPropagation(); vel=0; if(raf)cancelAnimationFrame(raf); pos=idx; raf=requestAnimationFrame(animate); }
        }, true);
        window.addEventListener('resize', function(){ if(sliderOn){ recalcGap(); render(); } });

        function gfSetView(v){
          sliderOn=(v==='slider');
          grid.classList.toggle('grifo-coverflow', sliderOn);
          wrap.classList.toggle('grifo-coverflow-wrap', sliderOn);
          var b=bar.querySelectorAll('button');
          for(var i=0;i<b.length;i++){ b[i].classList.toggle('on', b[i].getAttribute('data-v')===v); }
          if(sliderOn){ recalcGap(); render(); }
          else{ for(var j=0;j<N;j++){ var c=cards[j]; c.classList.remove('is-center'); c.style.cssText=''; } }
        }
        bar.addEventListener('click', function(e){ var t=e.target.closest('button'); if(t) gfSetView(t.getAttribute('data-v')); });
        gfSetView('slider');
      }
    }

    // barra de compra fija (móvil) en ficha de producto
    var gSticky=document.getElementById('grifoSticky');
    var gBuy=document.querySelector('.product-form__buttons')||document.querySelector('.product-form');
    if(gSticky&&gBuy&&'IntersectionObserver' in window){
      var so=new IntersectionObserver(function(es){es.forEach(function(e){
        gSticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top<0);
      });});
      so.observe(gBuy);
    }

    // popup 2x1
    var promo=document.querySelector('.grifo-promo');
    if(promo){
      setTimeout(function(){promo.classList.add('show');}, 3500);
      var x=promo.querySelector('.x'); if(x)x.onclick=function(){promo.classList.remove('show');};
      var cta=promo.querySelector('.cta'); if(cta)cta.addEventListener('click',function(){promo.classList.remove('show');});
    }
  });
})();
